import type { PRNG } from 'seedrandom';
import seedrandom from 'seedrandom';
import { type HexTileType, HexTileTypeList } from '../../model/types';

function createRandomGenerator(seed: number | string): PRNG {
  return seedrandom(String(seed));
}

function getRandomHexTileType(generator: PRNG): HexTileType {
  return HexTileTypeList[Math.floor(generator() * (HexTileTypeList.length - 1)) + 1];
}

export { createRandomGenerator, getRandomHexTileType };
